<template>
  <div>
    <Head :title="title" />

    <jet-banner />

    <div class="flex flex-col min-h-screen bg-gray-100">
      <nav class="bg-white border-b border-gray-100">
        <!-- Primary Navigation Menu -->
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="flex justify-between h-16">
            <div class="flex">
              <!-- Logo -->
              <div class="flex-shrink-0 flex items-center">
                <!-- TODO:学校側ダッシュボード画面表示時リンク先修正 -->
                <inertia-link :href="route('school.students')">
                  <img
                    class="mx-auto h-8 w-auto"
                    src="/img/andVet_logo.png">
                </inertia-link>
              </div>

              <!-- Navigation Links -->
              <div class="hidden space-x-8 text-base sm:-my-px sm:ml-10 sm:flex">
                <!-- <jet-nav-link
                  :href="route('school.dashboard')"
                  :active="route().current('school.dashboard')">
                  ダッシュボード
                </jet-nav-link> -->
                <jet-nav-link
                  :href="route('school.students')"
                  :active="route().current('school.students')">
                  学生一覧
                </jet-nav-link>
                <jet-nav-link
                  :href="route('school.result')"
                  :active="route().current('school.result')">
                  成績
                </jet-nav-link>
              </div>
            </div>

            <div class="flex items-center ml-14">
              <!-- Settings Dropdown -->
              <div class="ml-3 relative">
                <jet-dropdown
                  align="right"
                  width="48">
                  <template #trigger>
                    <div class="relative">
                      <span class="inline-flex rounded-md">
                        <button
                          type="button"
                          class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-gray-500 bg-white hover:text-gray-700 focus:outline-none transition">
                          <div class="w-[40vw] md:w-[20vw] text-right whitespace-nowrap overflow-x-hidden overflow-ellipsis">{{ clientUserEmail }}</div>
                          <svg
                            class="ml-2 -mr-0.5 h-4 w-4"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor">
                            <path
                              fill-rule="evenodd"
                              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                              clip-rule="evenodd" />
                          </svg>
                        </button>
                      </span>
                      <!-- <p class="absolute right-6 top-7 text-sm text-gray-500">{{VerifiedEmailText}}</p> -->
                    </div>
                  </template>

                  <template #content>
                    <!-- <div class="block px-4 py-2 text-xs text-gray-400">
                      アカウント管理
                    </div> -->

                    <jet-dropdown-link :href="route('school.credential.show')">
                      認証情報変更
                    </jet-dropdown-link>

                    <div class="border-t border-gray-100"></div>

                    <jet-dropdown-link :href="route('school.profile.show')">
                      プロフィール変更
                    </jet-dropdown-link>

                    <div class="border-t border-gray-100"></div>

                    <form @submit.prevent="logout">
                      <jet-dropdown-link as="button">
                        ログアウト
                      </jet-dropdown-link>
                    </form>
                  </template>
                </jet-dropdown>
              </div>
              <button
                class="relative z-20 sm:hidden h-5 w-6"
                @click="toggleBtn">
                <span
                  :class="isOpen ? 'transform rotate-45 top-2 w-7 transition duration-300' : 'top-0 w-6'"
                  class="h-0.5 rounded inline-block transition-all absolute right-0 bg-black"></span>
                <span
                  :class="isOpen ? 'hidden' : 'top-2 w-6'"
                  class="h-0.5 inline-block transition-all absolute right-0 bg-black"></span>
                <span
                  :class="isOpen ? 'transform -rotate-45 top-2 w-7 transition duration-300' : 'top-4 w-6'"
                  class="h-0.5 rounded inline-block transition-all absolute right-0 bg-black"></span>
              </button>
            </div>
          </div>
        </div>
      </nav>

      <!-- Page Heading -->
      <!-- <header
        class="bg-white shadow"
        v-if="$slots.header">
        <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
          <slot name="header"></slot>
        </div>
      </header> -->

      <!-- Page Content -->
      <main class="flex-grow">
        <slot></slot>
        <flash-messages
          :on="$attrs.flash" />
      </main>
      <div class="text-left">
        <nav
          :class="isOpen ? '-right-0 opacity-100' : '-right-full opacity-0'"
          class="fixed z-10 bg-white top-0 button-0 text-current w-52 h-screen transition-all duration-300">
          <div class="pt-12 px-6">
            <ul class="m-0 p-0 list-none">
              <!-- <li class="m-0 border-b-2">
                <a
                  class="block text-gray-600 active:text-gray-300 text-sm p-3 no-underline duration-150"
                  :href="route('school.dashboard')"
                  :active="route().current('school.dashboard')">ダッシュボード</a>
              </li> -->
              <li class="m-0 border-b-2">
                <a
                  class="block text-gray-600 active:text-gray-300 text-sm p-3 no-underline duration-150"
                  :href="route('school.students')"
                  :active="route().current('school.students')">学生一覧</a>
              </li>
              <li class="m-0 border-b-2">
                <a
                  class="block text-gray-600 active:text-gray-300 text-sm p-3 no-underline duration-150"
                  :href="route('school.result')"
                  :active="route().current('school.result')">成績</a>
              </li>
            </ul>
          </div>
        </nav>
        <div
          :class="isOpen ? 'block bg-black w-full h-full top-0 left-0 fixed opacity-80 z-2 cursor-pointer' : 'hidden transition-all duration-500'"
          @click="toggleBtn"></div>
      </div>

      <!-- <footer
        class="bg-white shadow">
        <div class="max-w-7xl flex justify-center md:justify-end text-left text-sm mx-auto py-6 sm:px-4 lg:px-8">
          <div class="text-gray-600 px-2 hover:text-black">
            <a
              class="block"
              :href="route('guide.company')">運営会社について</a>
          </div>
          <div class="text-gray-600 px-2">
            <a
              class="block hover:text-black"
              :href="route('guide.terms')">利用規約</a>
            <a
              class="block pt-3 hover:text-black"
              :href="route('guide.privacy')">プライバシーポリシー</a>
            <a
              class="block pt-3 hover:text-black"
              :href="route('guide.asct')">特定商取引法に基づく表記</a>
          </div>
        </div>
      </footer> -->
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { Head, Link, usePage } from '@inertiajs/inertia-vue3'
import JetApplicationMark from '@/Jetstream/ApplicationMark'
import JetBanner from '@/Jetstream/Banner'
import JetDropdown from '@/Jetstream/Dropdown'
import JetDropdownLink from '@/Jetstream/DropdownLink'
import JetNavLink from '@/Jetstream/NavLink'
import FlashMessages from '@/Common/FlashMessages'

const isOpen = ref(false)
const scrollControl = () => {
  if (isOpen.value) {
    document.documentElement.style.overflow = 'hidden'
  } else {
    document.documentElement.style.overflow = 'auto'
  }
}
const toggleBtn = () => {
  isOpen.value = !isOpen.value
  scrollControl()
}

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
})

const clientUserEmail = computed(() => {
  const emailName = usePage().props.value.client.user.email
  return emailName.substring(0, emailName.lastIndexOf('@'))
})

const VerifiedEmailText = computed(() => {
  const isClientVerifiedEmail = usePage().props.value.client.isVerifiedEmail
  return isClientVerifiedEmail ? '認証済' : '未認証'
})

const showingNavigationDropdown = ref(false)

const logout = () => Inertia.post(route('school.logout.post'))
</script>
